module.exports = __webpack_public_path__ + "images/index/img09.ad9eaf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/artfriends/img09.jpg
// module id = U4c/
// module chunks = 21